function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  className: "chevron-down_svg__a",
  d: "M11 11.67l9.1-9.09a1.11 1.11 0 00.33-.79A1.13 1.13 0 0020.1 1l-.67-.67a1.13 1.13 0 00-1.58 0L10.22 8 2.58.33A1.13 1.13 0 001.79 0 1.11 1.11 0 001 .33L.33 1a1.11 1.11 0 000 1.58l9.09 9.09a1.15 1.15 0 00.8.33 1.11 1.11 0 00.78-.33z"
});

function SvgChevronDown(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20.43 12"
  }, props), _ref);
}

export default __webpack_public_path__ + "assets/images/chevron-down.8db866df.svg";
export { SvgChevronDown as ReactComponent };